import { ArrowRight, ArrowUpRight, MousePointerClick } from 'lucide-react';
import { Button } from 'primereact/button';
import { FC, useRef } from 'react';
import { DiagnosticVideo, DiagnosticVideoHandle } from '../../DiagnosticUI/DiagnosticVideo';
import { useNavigate } from 'react-router-dom';

const TeacherDiagnosticPrepDiagnosticContent: FC = () => {
  const navigate = useNavigate();
  const videoRef = useRef<DiagnosticVideoHandle | null>(null);
  return (
    <div className="tw-flex tw-flex-col tw-gap-y-8 lg:tw-flex-row lg:tw-gap-x-8 tw-pt-8 ">
      <div className="nc_diagnostic-content-teacher-preview tw-bg-indigo-50 tw-justify-between tw-flex lg:tw-flex-col lg:tw-gap-y-4 lg:tw-w-[35%] tw-flex-row tw-gap-x-4 tw-p-10">
        <div className="tw-flex tw-flex-col tw-gap-y-4 tw-items-start tw-w-[50%] lg:tw-w-[100%]">
          <span className="tw-border-2 tw-border-solid tw-border-amber-200 tw-bg-amber-100 tw-text-amber-800 tw-text-xs tw-font-bold tw-rounded-xl tw-px-2 tw-py-1 tw-flex tw-flex-row tw-gap-x-1 tw-items-center tw-font-atkinson">
            <MousePointerClick size={12} className="tw-text-neutral-950" />
            Interactive demo
          </span>
          <h1 className="tw-font-bold tw-font-sora tw-text-xl tw-text-neutral-950">
            See what your students will experience
          </h1>

          <p className="tw-text-neutral-950 tw-text-base tw-font-atkinson tw-m-0 ">
            Check out the types of questions your students will be asked and get a sense of the overall experience
          </p>
          <Button
            label="Try it out"
            className="tw-gap-x-2 tw-flex tw-flex-row-reverse lg:tw-hidden"
            icon={<ArrowRight size={16} />}
            iconPos="right"
            onClick={() => navigate('/diagnostic-preview')}
          />
        </div>
        <img
          src={'/diagnostic_preview.png'}
          alt="diagnostic_preview"
          className="lg:tw-w-full tw-h-auto tw-object-contain tw-w-[50%]"
        />
        <Button
          label="Try it out"
          className=" tw-gap-x-2 lg:tw-flex lg:tw-flex-row-reverse tw-hidden"
          icon={<ArrowRight size={16} />}
          iconPos="right"
          onClick={() => navigate('/diagnostic-preview')}
        />
      </div>

      <div className="tw-flex tw-flex-col tw-gap-y-4 lg:tw-w-[65%]">
        <h1 className="tw-font-bold tw-font-sora tw-text-xl tw-text-neutral-950">
          The diagnostic, explained in 2 mins
        </h1>
        <div className="tw-flex tw-flex-row tw-justify-between tw-items-center">
          <p className="tw-text-neutral-950 tw-text-base tw-font-atkinson tw-m-0 ">
            Made for students, share it with your class or preview what they&apos;ll experience.
          </p>
          <Button
            label="Play for your class"
            link
            className="tw-gap-x-2 tw-flex tw-flex-row-reverse"
            icon={<ArrowUpRight size={16} />}
            iconPos="right"
            onClick={() => videoRef.current?.toggleFullscreen()}
          />
        </div>
        <DiagnosticVideo ref={videoRef} />
      </div>
    </div>
  );
};

export default TeacherDiagnosticPrepDiagnosticContent;
